import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { autenticar, getRole } from "../services/api";

export function RotaPrivada({ children, roles}) {
  const navigate = useNavigate();
  const user = getRole()

  useEffect(() => {
    autenticarToken();
  }, []);

  async function autenticarToken() {
    try {
      await autenticar();

      if (!roles.includes(user.role)){
        localStorage.removeItem("authToken")
        navigate("/login")
        return
      }
      
    } catch (error) {
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  }
  return children;
}
